import { hotelsEn } from './en'

export const hotelsEnUs = { ...hotelsEn }
